import styled from "styled-components";
import { SIDEBAR_W, TOPBAR_H } from "../../config/layout";

export const Sidebar = styled.aside`
  width: ${SIDEBAR_W};
  min-width: ${SIDEBAR_W};
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: fixed;
  top: ${TOPBAR_H};
  left: 0;
  bottom: 0;
  z-index: 100;
  border-right: 1px solid #e0e8f0;
`;

export const Nav = styled.nav`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const NavItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 18px;
  background: ${({ $active }) => ($active ? "#3d7a8a" : "none")};
  border: none;
  color: ${({ $active }) => ($active ? "#fff" : "#555")};
  font-size: 0.85rem;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  text-align: left;
  cursor: pointer;
  width: 100%;

  &:hover {
    background: ${({ $active }) => ($active ? "#3d7a8a" : "#f0f6f8")};
    color: ${({ $active }) => ($active ? "#fff" : "#26A9B6")};
  }
`;

export const PatientPreview = styled.div`
  padding: 14px 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e8f0f7;
  border-top: 1px solid #e8f0f7;
  background: #f8fbfd;
`;

export const PatientPreviewAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #e8f0f7;
  flex-shrink: 0;
`;

export const PatientPreviewCode = styled.span`
  color: #1b3a6b;
  font-size: 0.78rem;
  font-weight: 600;
  word-break: break-all;
`;

export const SidebarBottom = styled.div`
  background: #f5f7f9;
  border-top: 1px solid #e0e8f0;
  padding: 6px 0;
`;

export const SidebarLink = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 18px;
  background: ${({ $active }) => ($active ? "#3d7a8a" : "none")};
  color: ${({ $active }) => ($active ? "#fff" : "#555")};
  font-size: 0.85rem;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${({ $active }) => ($active ? "#fff" : "#26A9B6")};
    background: ${({ $active }) => ($active ? "#3d7a8a" : "#edf3f5")};
  }
`;
